import React from 'react';
import { Dialog, InputLabel, Box } from '@mui/material';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import { AppDialogTitle } from '../../layout/appDialogTitle';
import { AppRow } from '../../layout/appRow';
import { OnEditParams } from '../../models/holidays';
import {
  AppControlledCalendar,
  InputFormat,
} from '../app/appControlledCalendar';
import { AppButton } from '../app/button/appButton';
import { AppControlledTextField } from '../app/input/appControlledTextField';
import {
   formatDateOnly,
} from '../../services/dateService';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  handleEditHoliday: SubmitHandler<FieldValues>;
  selectedHoliday: OnEditParams;
}

export default function EditHolidayDialog({
  isOpen,
  handleClose,
  handleEditHoliday,
  selectedHoliday,
}: Props): JSX.Element {
  const methods = useForm();

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: {
          margin: 0,
        },
      }}
    >
      <AppDialogTitle title="Edit holiday" handleClose={handleClose} />
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleEditHoliday)}>
          <Box sx={{ pl: 4, pr: 4, pt: 4 }}>
            <AppRow sx={{ mb: 3 }}>
              <InputLabel>Date</InputLabel>
              <AppControlledCalendar
                name="dayOffDate"
                defaultValue={new Date(formatDateOnly(selectedHoliday.dayOffDate))}
                inputFormat={InputFormat.SEPARATOR_SPACE}
                sx={{ width: '160px' }}
              />
            </AppRow>
            <AppRow>
              <AppControlledTextField
                name="name"
                label="Official Name"
                sx={{ width: '100%', mb: 3 }}
                variant="filled"
                defaultValue={selectedHoliday.name}
                disabled
                isRequired
              />
            </AppRow>
            <AppRow>
              <AppControlledTextField
                name="id"
                label="ID"
                sx={{ display: 'none' }}
                variant="filled"
                defaultValue={selectedHoliday.id}
                isRequired
              />
            </AppRow>
          </Box>
          <AppRow>
            <AppButton label="Cancel" onClick={handleClose} />
            <AppButton label="Save" isPrimary buttonType="submit" />
          </AppRow>
        </form>
      </FormProvider>
    </Dialog>
  );
}
